import React from 'react'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { FormSection } from './FormKit'

const SupportingInformation = ({ formValues, setFormValues }) => {
  const statement = formValues?.personalStatement ?? ''
  const words = statement.trim() ? statement.trim().split(/\s+/).length : 0
  return (
    <FormSection
      title="Supporting statement"
      caption="This is your chance to tell us how your qualifications, skills and experience match the role — and anything else you'd like us to know."
    >
      <TextField
        multiline
        minRows={12}
        fullWidth
        value={statement}
        onChange={(e) =>
          setFormValues((prev) => ({
            ...prev,
            personalStatement: e.target.value,
          }))
        }
        placeholder="Start writing here…"
      />
      <Typography variant="caption" color="text.secondary" textAlign="right">
        {words} {words === 1 ? 'word' : 'words'}
      </Typography>
    </FormSection>
  )
}

export default SupportingInformation
